// extracted by mini-css-extract-plugin
module.exports = {"favoriteToast":"FavoritesToastContent_favoriteToast__a9kj5"};